export const environment = {
  production: false,
  environmentName: 'QA',
  apiUrl: 'https://api-qr.dev-limprod.com',
  // apiLogin: 'https://sevicelogin-qa.claroutmservice.com', // API externa ya no disponible
  tokenLogin: 'desktop-qa',
  studentPortalUrl: 'https://qr-qa.dev-limprod.com',
  googleClientId: '367414571491-tp1n99hm5ek0525sflr0c0jro3040hpk.apps.googleusercontent.com',
  studentType: 'estudiante',
  executiveType: 'administrativo',
  pregradoLevel: 'pregrado',
  posgradoLevel: 'posgrado',
  continuaLevel: 'continua',
  requestCriticality: {
    red: 90,
    yellow: 50,
  },
  enableDebugLogs: true,
  apiTimeout: 30000, // 30 segundos
};
